export { default as FixedHeader } from './header/index'
export { default as FixedFooter } from './footer/index'

